import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, Col, Row } from 'react-bootstrap';
import ShopOfferItem from '../common/ShopOfferItem/ShopOfferItem.jsx';
import DeleteConfirmButton from '../common/Buttons/DeleteConfirmButton.jsx';
import ImageEditor from '../common/FormFileds/ImageEditor/ImageEditor.jsx';


function OffersItem(props) {
  let [imageFetching, setImageFetching] = useState(false);

  const handleDeleteClick = () => {
    props.onDelete(props.type, props.id);
  }

  const handleChangeImage = (formData) => {
    setImageFetching(true);
    props.onChangeImage(formData, props.id, props.is_moderator).then(() => setImageFetching(false));
  };

  const imageBlock = <ImageEditor id={ props.id }
                                  image={ props.image }
                                  scaleImage={ true }
                                  isFetching={ imageFetching }
                                  fieldName={ 'image' }
                                  onChange={ handleChangeImage }
                                  emptyPlaceholder={ '/static/base/images/no-image-available.png' }
                                  entryName={ gettext('изображение') }/>

  return <ShopOfferItem key={ props.id } {...props} imageBlock={ imageBlock }>
    <Row className='mb-3'>
      <Col xs={12} md={8}>
        <Button href={ props.url } variant='outline-dark' size='sm' className='mr-2'>
          { gettext('Смотреть') } <i className='icon icon-right-circled'></i>
        </Button>
        { !props.freeze && <Link className='btn btn-sm btn-outline-dark' to={ props.id + '/' } >
          <i className='icon icon-pencil'></i> { gettext('Редактировать') }
        </Link> }
      </Col>
      { !props.is_buy && <Col className='text-md-right mt-2 mt-md-0' xs={12} md={4}>
        <DeleteConfirmButton onDeleteClick={ handleDeleteClick }
                             title={ gettext('Удалить') }
                             variant='light'/>
      </Col> }
    </Row>
  </ShopOfferItem>
}

OffersItem.propTypes = {
  id: PropTypes.number.isRequired,
}


export default compose(connect(null, {}))(OffersItem);

